import * as React from 'react'

import { Merge, Plus, SquarePen } from 'lucide-react'

import ListSelectionToolbar from '~/client/src/desktop/tables/ListSelectionToolbar'
import type { UseTableListResult } from '~/client/src/desktop/tables/useTableList'
import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { MergeAvailability } from '../companySelectionActions'
import { ICompanyRow } from '../types'

interface ISelectionToolbarProps {
  list: UseTableListResult<ICompanyRow>
  merge: MergeAvailability
  onEdit: () => void
  onMerge: () => void
  onAddCompany: () => void
}

export default function SelectionToolbar({
  list,
  merge,
  onEdit,
  onMerge,
  onAddCompany,
}: ISelectionToolbarProps): React.ReactElement {
  const t = Localization.translator

  return (
    <ListSelectionToolbar
      list={list}
      countLabel={t.xCompaniesCount(list.model.filteredCount)}
      selectionActions={
        <>
          <Button variant="primary-ghost" onClick={onEdit}>
            <SquarePen aria-hidden="true" />
            {t.edit_verb}
          </Button>
          {merge !== MergeAvailability.Hidden && (
            <Button
              variant="primary-ghost"
              onClick={onMerge}
              disabled={merge === MergeAvailability.Disabled}
            >
              <Merge aria-hidden="true" />
              {t.merge_verb}
            </Button>
          )}
        </>
      }
    >
      <Button size="lg" onClick={onAddCompany}>
        <Plus aria-hidden="true" />
        {t.addCompany}
      </Button>
    </ListSelectionToolbar>
  )
}
